import NavTabs from 'components/NavTabs'
import PieChart from 'components/PieChart'

const tabs = ['Pages', 'Sources', 'Contributions', 'Events']

const pieHeaders = {
  pages: ['Page', 'Users'],
  sources: ['Source', 'Visitors'],
  contributions: ['Author', 'Changes'],
  events: ['Action', 'Users']
}

const PieList = props => (
  <div className='pie-list'>
    <NavTabs {...{ tabs }} onClick={props.onClick} selected={props.selected} />
    <div style={{ height: '55%' }}>
      <PieChart data={props[props.selected]} />
    </div>
    <div className='pie-slices'>
      <div className='pie-slice'>
        { pieHeaders[props.selected].map(h => <div key={h}><strong>{ h }</strong></div>) }
      </div>
      { props[props.selected].slice(0, 5).map(x =>
        <div key={x.label} className='pie-slice'>
          <div>{ x.label.slice(0, 30) }</div>
          <div>{ x.value }</div>
        </div>
      ) }
    </div>
  </div>
)

export default PieList
